/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faMessage,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import SearchIcon from "../../assets/icons/search.svg2";
import { useGetBroadcastMessagingReportDataQuery } from "../store/slices/widgetsSlice";
import { Link } from "react-router-dom";
import MyPagination from "../Common/MyPagination";

const columnOptions = [
  { value: "Reference", label: "Reference" },
  // { value: "Label", label: "Label" },
  { value: "CreatedAt", label: "Date" },
  { value: "Dispatched", label: "Sent" },
  { value: "Delivered", label: "Delivered" },
  { value: "Failed", label: "Failed" },
  { value: "Expired", label: "Expired" },
  { value: "Replies", label: "Replies" },
  { value: "Description", label: "Description" },
];

// search field options
const searchFieldOptions = [
  { value: "", label: "All" },
  { value: "label", label: "Label" },
  { value: "description", label: "Description" },
  { value: "reference", label: "Reference" },
];

export default function BroadcastMessaging({ showTransactions = true }) {
  const [inputText, setInputText] = useState("");
  const [search, setSearch] = useState("");
  const [search_field, setSearch_field] = useState("description");
  useEffect(() => {
    const t = setTimeout(() => {
      setSearch(inputText);
    }, 300);

    return () => {
      clearTimeout(t);
    };
  }, [inputText]);
  const [order, setOrder] = useState("desc");
  const [order_by, setOrder_by] = useState("created_at");
  const [columnsToShow, setColumnsToShow] = useState(
    localStorage.getItem("BroadcastMessagingOverviewColumns")
      ? JSON.parse(localStorage.getItem("BroadcastMessagingOverviewColumns"))
      : ["report", "Reference", "Label", "CreatedAt", "Delivered", "Replies"]
  );

  const [date_gte, setDate_gte] = useState();
  const [date_lte, setDate_lte] = useState();
  const [page, setPage] = useState(0);
  const [per_page, setPerPage] = useState(10);

  // search field ekle
  const {
    data: { broadcasts, total } = { broadcasts: [], total: 0 },
    refetch,
  } =
    useGetBroadcastMessagingReportDataQuery({
      order_by,
      order,
      search,
      search_field,
      date_gte,
      date_lte,
      page,
      per_page,
    });

  return (
    <div>
      <div className="mb-3">
        <div className="d-flex justify-content-end gap-3">
          <div className="position-relative">
            <Input
              placeholder="Search"
              value={[inputText]}
              onChange={([v]) => {
                setInputText(v);
              }}
            />
            <SearchIcon
              width={30}
              heigth={30}
              className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
              style={{ marginRight: -10 }}
            />
          </div>
          <DropdownButton
            id="show-colums-dropdown"
            title="Show columns"
            variant="colored"
            autoClose="outside"
            align="end"
            className="h-100 rounded-3"
          >
            {columnOptions.map((c) => (
              <Dropdown.Item as="div" key={c.value}>
                <Form.Check
                  checked={columnsToShow.includes(c.value)}
                  label={c.label}
                  id={`${c.value}-checkbox`}
                  onChange={() => {
                    setColumnsToShow((p) => {
                      let newColumns;
                      if (p.includes(c.value)) {
                        newColumns = p.filter((pc) => pc !== c.value);
                      } else {
                        newColumns = [...p, c.value];
                      }
                      localStorage.setItem(
                        "BroadcastMessagingOverviewColumns",
                        JSON.stringify(newColumns)
                      );
                      return newColumns;
                    });
                  }}
                />
              </Dropdown.Item>
            ))}
          </DropdownButton>
          <button
            type="button"
            className="btn btn-sm border-0"
            onClick={refetch}
            title="Refresh"
          >
            <FontAwesomeIcon icon={faRotateLeft} />
          </button>
        </div>

        {/* <div className="col-12 col-xxl-4 col-lg-6">
          <Input
            label="Search field"
            inputType="select"
            value={[search_field]}
            onChange={([v]) => setSearch_field(v)}
            options={searchFieldOptions}
            placeholder="Search field"
          />
        </div> */}
        {/* <div className="col-12 col-xxl-4 col-lg-6">
          <Input
            label="After"
            inputType="dateTime"
            dateTimeType="dateTime"
            value={[date_gte]}
            onChange={([v]) => setDate_gte(v)}
          />
        </div> */}
        {/* <div className="col-12 col-xxl-4 col-lg-6">
          <Input
            label="Before"
            inputType="dateTime"
            dateTimeType="dateTime"
            value={[date_lte]}
            onChange={([v]) => setDate_lte(v)}
          />
        </div> */}
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            {showTransactions && (
              <th>
                <button
                  className="btn btn-link p-0"
                  type="button"
                  onClick={() => {
                    if (order_by !== "Label") {
                      setOrder_by("Label");
                      setOrder("desc");
                    } else {
                      setOrder((p) => (p === "asc" ? "desc" : "asc"));
                    }
                  }}
                >
                  Label
                  {order_by === "Label" && (
                    <FontAwesomeIcon
                      className="ms-2"
                      icon={order === "asc" ? faAngleUp : faAngleDown}
                    />
                  )}
                </button>
              </th>
            )}
            {columnOptions
              .filter((c) => columnsToShow.includes(c.value))
              .map((c) => (
                <th key={c.label}>
                  {/* Sort by column */}
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => {
                      if (order_by !== c.label) {
                        setOrder_by(c.label);
                        setOrder("desc");
                      } else {
                        setOrder((p) => (p === "asc" ? "desc" : "asc"));
                      }
                    }}
                  >
                    {c.label}
                    {order_by === c.label && (
                      <FontAwesomeIcon
                        className="ms-2"
                        icon={order === "asc" ? faAngleUp : faAngleDown}
                      />
                    )}
                  </button>
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {broadcasts.map((b) => (
            <tr key={b.Uuid}>
              {showTransactions && (
                <td>
                  {b.Label}{" "}
                  <Link
                    to={`/reporting/realtime/broadcast?broadcastUUID=${b.Broadcast?.Uuid}&startDate=${b.CreatedAt}`}
                    className="btn btn-link p-0"
                    title="View transactions"
                  >
                    <FontAwesomeIcon icon={faMessage} />
                  </Link>
                </td>
              )}
              {columnOptions
                .filter((c) => columnsToShow.includes(c.value))
                .map((c) => (
                  <td>
                    {c.value === "CreatedAt"
                      ? new Date(b[c.value]).toLocaleString()
                      : b[c.value]}
                  </td>
                ))}
            </tr>
          ))}
          {!broadcasts.length && (
            <tr>
              <td
                className="text-center text-secondary"
                colSpan={
                  (showTransactions ? 1 : 0) +
                  columnOptions.filter((c) => columnsToShow.includes(c.value))
                    .length
                }
              >
                No broadcast messaging found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <MyPagination
        total={total}
        onPaginate={(p, pp) => {
          setPage(p);
          setPerPage(pp);
        }}
        perPageOptions={[10, 25, 50]}
        defaultPerPage={10}
        alwaysVisible
      />
    </div>
  );
}
